import './featuredProjects.scss';
import * as React from 'react';
import useFeaturedProjects from '../../hooks/staticQueries/projects/useFeaturedProjects';
import { SectionTitle } from '../layout/sectionTitle';
import { ProjectListItemCarousel } from './projectListItemCarousel';
export const FeaturedProjects = () => {
    const { projects, copy } = useFeaturedProjects();
    return (<div className="featured-projects">
      <SectionTitle title={copy.header} description={copy.description} imageTicket={copy.icon[0].ticket} button={{
        to: '/projects',
        variant: 'brand-tertiary',
        children: 'Projects',
    }}/>

      <ProjectListItemCarousel projects={projects} analyticsId="Featured Projects"/>
    </div>);
};
